import moment from "moment";
import {Invoice} from "../../../CRUDs/entities/Invoice";
import {PaymentForm} from "../../../customer-cab/PaymentForm";
import {Quote} from "../../../CRUDs/entities/Quote";
import { Job } from "../../../CRUDs/entities/Job";
import { Order } from "../../../CRUDs/entities/Order";
import {ApproveQuoteForm} from "../../../customer-cab/ApproveQuoteForm";
import { HasWorkers } from "../../../CRUDs/abstracts/mixins/HasWorkers";
import { SaveButton } from "../../../components/SaveButton";
import {CheckList} from '../../../CRUDs/entities/CheckList';
import masks from "../../../masks.js";
import { CRUDFabric } from "../../../CRUDs/CRUDFabric.js";
import { InputSelector } from "../../../components/InputSelector.js";
import { dispatchLivewireEvent, onLivewireEvent, refreshLivewireTree } from "../../../Common/livewireCompat";

export default {
    init() {
        this.getCategoriesModal();
        this.getActionCategoryModal();
        this.recordsToShowChange();
        this.getCompleteForm();
        this.getFormForSubscriptionEditing();
        this.editSubscription();
        this.getIntegrationModal();
        this.completeFormServiceChange();
        this.createSubscriptionRequest();
        this.showSelectedServicesAttributes();
        this.editOrder();
        this.changeStatus();
        this.getRescheduleModal();
        this.findOrder();
        this.assignWorkers();
        this.moreInfoOrder();
        this.openViewInvoiceModal();
        this.openPayInvoice();
        this.allMoreInfo();
        //this.openViewQuote();
        //this.openApproveQuote();
        this.moreInfoSubscription();
        this.openJobDetail();
        this.openJobInvoices();
        this.checkStatusClass();
        this.getDetailsForm();
        this.saveChecklistJobsDone();
        this.markChecklistItemsDone();
        this.viewChecklist();
        this.viewChecklistLog();
        this.leaveComments();
    },
    getCategoriesModal() {
        $('.categories-list__table-controls-button-add').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/services-management/categories/get-form',
                success: function (response) {
                    $('#form-container').html(response);
                    $('#category-modal').modal('show');
                }
            });
        });
    },
    getActionCategoryModal() {
        let _this = this;
        $('.categories-list__table-controls-row-item').click(function (e) {

            let action = $(this).data('action');

            if (action == 'delete')
                return true;

            e.preventDefault();

            let category_id = $(this).data('category-id');
            if (action) {
                switch (action) {
                    case 'edit':
                        $.ajax({
                            type: 'GET',
                            url: '/services-management/categories/get-form',
                            data: {
                                category_id
                            },
                            success: (response) => {
                                $('#form-container').html(response);
                                $('#category-modal').modal('show');
                                _this.getCategoriesSorted();
                            }
                        });
                        break;
                    case 'view':
                        $.ajax({
                            type: 'GET',
                            data: {
                                category_id
                            },
                            url: '/services-management/categories/get-complete-form',
                            success: (response) => {
                                $('#form-container').html(response);
                                refreshLivewireTree('#service-request-modal');
                                $('#service-request-modal').modal('show');
                                _this.completeFormServiceChange();
                                _this.completeFormCategoryChange();
                                $('select[name="category"]').parents('.form-group').hide();
                            }
                        });
                        break;
                }
            }
        });
    },
    getCategoriesSorted() {
        let _this = this;
        if ($('.category-modal__product-input:checked').length <= 1)
            return false;

        $('.category-modal__sort-button').click(function (e) {
            e.preventDefault();
            if ($(this).hasClass('sort_disabled'))
                return false;

            let action = $(this).data('sort-direction');
            let productId = $(this).parent().data('sort-for');
            let categoryId = $(this).parent().data('category-id');
            //console.log(action, productId, categoryId);

            $.ajax({
                type: 'GET',
                url: '/services-management/categories/get-inner-form',
                data: {
                    action,
                    productId,
                    categoryId
                },
                success: function (response) {
                    $('.category-modal__body').html(response);
                    _this.getCategoriesSorted();
                }
            });

        });
    },
    recordsToShowChange() {
        let _this = this;
        $('select[name="records_to_show"]').change(function (e) {
            let form = $(this).parents('form');
            if (form)
                form.submit();
        });
    },
    getCompleteForm() {
        $('body').on('click','.categories-list__links .complete-form-link, .services-pagelink.complete-form-link, #test-order, [data-create-order-link],#new-subscription', (e) => {
            e.preventDefault();
            let form_type = 'view';
            const type_name = $(e.currentTarget).attr('data-form-type');
            if (type_name !== undefined)
                form_type = type_name;
            const entity = $(e.currentTarget).attr('data-entity');
            let order_id = $(e.currentTarget).attr('data-order-id');
            const time_management = $(e.currentTarget).attr('data-time-management');

            $.ajax({
                type: 'GET',
                data: { form_type, entity, order_id, time_management },
                url: '/services-management/categories/get-complete-form',
                success: (response) => {
                    let serviceRequestModalExists = $('#service-request-modal').length;

                    $('#form-container').html(response);
                    $('#service-request-modal').modal('show');
                    refreshLivewireTree('#service-request-modal');
                    this.completeFormServiceChange();
                    this.completeFormCategoryChange();
                    if (!serviceRequestModalExists) this.createOrderRequest();
                    this.createSubscriptionRequest();
                    this.calculateOrderSubtotal();
                    this.serviceAttributeChangesValue();
                    this.tipsChange();
                    masks.init();
                    this.itemSelector = new InputSelector('#service-request-modal #customer-select')
                    $(this.itemSelector.element).on('select-item', (ev) => {
                        if(this.itemSelector.selectedValueField)
                            $(this.itemSelector.selectedValueField).attr('disabled',false)
                        $('.create-new-customer').addClass('d-none');
                    })
                    $(this.itemSelector.element).on('no-data', (ev) => {
                        if (ev.originalEvent.detail.value) {
                            $(this.itemSelector.noDataElement).find('.no-data-text').html(`<span>Create new customer <b>${ev.originalEvent.detail.value}</b></span>`)
                        }
                    })
                    $('.create-new-customer-button').on('click', (e) => {
                        if(this.itemSelector.selectedValueField)
                            $(this.itemSelector.selectedValueField).attr('disabled',true)
                        let inputValue = this.itemSelector.inputField.value.split(/\s+/)
                        if(inputValue.length){
                            $('#service-request-modal input[name="first_name"]').val(inputValue[0])
                            $('#service-request-modal input[name="last_name"]').val(inputValue?.[1] ?? '')
                        }
                        this.itemSelector.inputField.value = ''
                        this.itemSelector.toggleList(false)
                        this.itemSelector.filterItems()
                        e.preventDefault();
                        $('.create-new-customer').toggleClass('d-none');
                    });
                },
            });

        });
        $('body').on('click', '#orders .modal-inf', (e)=>{
            e.preventDefault();
            let form_type = 'view';
            const type_name = $(e.currentTarget).data('form-type');
            if (type_name !== undefined)
                form_type = type_name;
            const entity = $(e.target).data('entity');
            const order_id = $(e.currentTarget).data('order_id');

            $.ajax({
                type: 'GET',
                data: { form_type, entity, order_id },
                url: '/services-management/categories/get-complete-form',
                success: (response) => {
                    $('#form-container').html(response);
                    refreshLivewireTree('#service-request-modal');
                    $('#service-request-modal').modal('show');
                    this.completeFormServiceChange();
                    this.completeFormCategoryChange();
                    this.createOrderRequest();
                    this.createSubscriptionRequest();
                    this.calculateOrderSubtotal();
                    this.serviceAttributeChangesValue();
                    this.tipsChange();
                    this.dateStartChange();
                }
            });
        })
    },
    getFormForSubscriptionEditing() {
        $(document).on('click', '[data-origin] .edit a' , (e) => {
            e.preventDefault();

            const subscriptionId = $(e.target).parents('.data-row').data('origin');
            //const subscriptionInfo = this.getSubscriptionInfo(subscriptionId);
            const origin_id = $(e.target).parents('.data-row').data('origin');
            //console.log($(e.target), $(e.target).parents('.data-row'));
            $.ajax({
                type: 'GET',
                data: { form_type: 'edit', entity: 'subscription', subscription_id: origin_id },
                async: false,
                url: '/services-management/categories/get-complete-form',
                success: (response) => {
                    $('#form-container').html(response);
                    refreshLivewireTree('#service-request-modal');
                    $('#service-request-modal').modal('show');
                    //this.autocompleteGeneralInfoForSubscription(subscriptionInfo);
                    this.completeFormServiceChange();
                    this.completeFormCategoryChange();
                    this.createOrderRequest();
                    this.createSubscriptionRequest();
                    this.calculateOrderSubtotal();
                    this.serviceAttributeChangesValue();
                    this.tipsChange();
                    //this.autocompleteModifiersForSubscription(subscriptionInfo);
                    this.editSubscription();
                    this.dateStartChange();
                }
            });

        });
    },
    getSubscriptionInfo(subscriptionId) {
        let subscriptionInfo;
        $.ajax({
            type: 'GET',
            async: false,
            url: `/subscription/${subscriptionId}`,
            success: (response) => {
                subscriptionInfo = response;
            }
        });
        return subscriptionInfo;
    },
    autocompleteGeneralInfoForSubscription(subscriptionInfo) {
        let dateStart = new Date(subscriptionInfo.subscription.start_date);
        const form = $('#service-request-modal');
        form.find('[name=customer_id]').val(subscriptionInfo.subscription.customer_id);
        if (dateStart){
            let dateOption = document.createElement('option');
            dateOption.dataset.dynamic = '1';
            dateOption.selected = true;
            dateOption.value = moment(dateStart).format('YYYY-MM-DD');
            dateOption.innerHTML = moment(dateStart).format('ddd, MMM Do')
            form.find('[name=date]').prepend(dateOption);

            let timeOption = document.createElement('option');
            timeOption.dataset.dynamic = '1';
            timeOption.selected = true;
            timeOption.value = moment(dateStart).format('h:mm a');
            timeOption.innerHTML = `${moment(dateStart).format('h:mm a')} - ${moment(dateStart).format('h:mm a')}`;
            form.find('[name=time]').prepend(timeOption);
        }
        form.find('[name=category]').val(subscriptionInfo.category);
        form.find('[name=service]').val(subscriptionInfo.subscription.service_type);
        form.find('[name=id]').val(subscriptionInfo.subscription.id);
        form.find('textarea[name=comments]').val(subscriptionInfo.subscription.comments);
    },
    autocompleteModifiersForSubscription(subscriptionInfo) {
        const modalForm = $('#service-request-modal');
        const visibleModifiersList = modalForm.find('.modal-service-attributes__list:not(.d-none)');
        for (let checkedModifier of subscriptionInfo['checked_modifiers']) {
            const modifierElementSelect = visibleModifiersList.find(`select[name=modifier\\[${checkedModifier['id']}\\]]`);
            const modifierElementCheckbox = visibleModifiersList.find(`input[name=modifier\\[${checkedModifier['id']}\\]\\[\\]]`);

            if (modifierElementSelect.length) {
                $(`option[value='${checkedModifier['value']}']`, modifierElementSelect).attr('selected', true);
            }
            if (modifierElementCheckbox.length) {
                let multipleModifierValues = JSON.parse(checkedModifier['value']);
                for (let checkbox of modifierElementCheckbox) {
                    for (let checkedVal in multipleModifierValues){
                        if (checkbox.value == JSON.stringify(multipleModifierValues[checkedVal])) {
                            checkbox.checked = true;
                        }
                    }
                }
            }
        }
    },
    completeFormServiceChange() {
        $('select[name="service"]').on('change', function() {
            dispatchLivewireEvent('serviceSelected', [this.value]);
            dispatchLivewireEvent('serviceSelected2', [this.value]);

        });
        onLivewireEvent('serviceSelectedComplete', (flag) => {
            //if(flag){
                this.calculateOrderSubtotal();
                $('.snippet-form').find('select, c-selected-value').removeClass('bb-standard-select');
            //}
        });
        dispatchLivewireEvent('serviceSelected', [$('select[name="service"]').val()]);
        dispatchLivewireEvent('serviceSelected2', [$('select[name="service"]').val()]);
    },
    showSelectedServicesAttributes(selectName = '') {
        if (selectName == '' || selectName == undefined)
            return false;

        let serviceId = $('select[name="' + selectName + '"]').val();
        let serviceContainer = $('#service-content-' + serviceId);
        $('.modal-service-attributes__list').addClass('d-none');
        serviceContainer.removeClass('d-none');
    },
    completeFormCategoryChange() {
        $('select[name="category"]').on('change', function (e) {
            dispatchLivewireEvent('categorySelected', [this.value]);
        });
    },
    dateStartChange(){

        let _this = this;
        _this.dateStart('#service-request-modal select[name="date"], #reschedule-modal select[name="date"]', true);
        $('#service-request-modal select[name="date"], #reschedule-modal select[name="date"]').change((e) => {
            _this.dateStart('#service-request-modal select[name="date"], #reschedule-modal select[name="date"]');
        });
    },
    dateStart(selector = '', first = false){
        if (selector == '')
            return false;

        let dateSelect = $(selector);
        let timeSelect = $('#service-request-modal select[name="time"], #reschedule-modal select[name="time"]');
        let selectedDateOption = $('option:selected', dateSelect);
        let timeSelectOptions = $('option', timeSelect);
        timeSelectOptions.addClass('d-none');
        let neededOptions = $('option[data-order-date="' + selectedDateOption.val() + '"]', timeSelect);
        neededOptions.removeClass('d-none');
        if (!first){
            timeSelectOptions.removeAttr('selected');
            if (neededOptions.length){
                neededOptions[0].setAttribute('selected', true);
            }else{
                timeSelectOptions[0].setAttribute('selected', true);
            }
        }
    },
    getRescheduleModal(){
        let _this = this;
        $('body').on('click','.reschedule a', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let order_id = $(e.target).data('order-id');
            $.ajax({
                type: 'GET',
                url: '/reschedule/order/get-form/' + order_id,
                success: function (response) {
                    $('#form-container').html(response);
                    $('#reschedule-modal').modal('show');
                    _this.dateStartChange();
                }
            });
        });

        $('#reschedule').click((e) => {
            e.stopPropagation();
            let order_id = $('#order-id').html();
            $.ajax({
                type: 'GET',
                url: '/reschedule/order/get-form/' + order_id,
                success: function (response) {
                    $('#form-container').html(response);
                    $('#reschedule-modal').modal('show');
                    _this.dateStartChange();
                }
            });

        });
    },
    getIntegrationModal() {
        $('.get-integration-modal').on('click', function (e) {
            e.preventDefault();
            let serviceId = e.currentTarget.dataset.serviceId;
            $.ajax({
                type: 'GET',
                url: "/services-management/categories/get-integration-code/" + serviceId,
                success: function (response) {
                    $('#form-container').html(response);
                    $('#code-integration-modal').modal('show');
                }
            });

        });
    },
    createOrderRequest() {
        $('body').on('click', '.create-order-service', (e) => {
            e.preventDefault();
            let form = $(e.target).parents('form');
            $('[name="time"]').find('option:selected').val($('[name="time"]').find('option:selected').text());
            let formData = $('[name]', form).serialize();
            this.nextOrderStep(formData, form);
        });
    },
    nextOrderStep(prevStepData, prevForm){
        let prevStep = prevForm.data('step');
        let nextStep = prevStep + 1;
        let nextForm = $('.order-form-step-' + nextStep);
        $('.order-form-steps').addClass('d-none');
        nextForm.toggleClass('d-none');
        $('#service-request-modal .modal-title').text('Add a Customer');
        $('button', nextForm).off();
        $('button', nextForm).click((e) => {
            e.preventDefault();

            let validateResult = true;

            if (!$('.create-new-customer').hasClass('d-none')) {
                validateResult = this.validateCustomer();
            }

            if (validateResult) {
                let SaveBtn = new SaveButton('.order-form-step-' + nextStep);
                let formData = nextForm.serialize() + '&' + prevStepData;
                if ($('#send_email').length > 0 && !$('#send_email').is(':disabled')) {
                    formData = formData.replace('send_email=on', 'send_email=' + ($('#send_email').is(':checked') ? 'true' : 'false'));
                }

                $.ajax({
                    type: 'POST',
                    data: formData,
                    url: '/create-order',
                    beforeSend: () => {
                        SaveBtn.startLoading();
                    },
                    success: function (response) {
                        if(response?.success){
                            SaveBtn.stopLoading(true).then(
                                () => {
                                    SaveBtn.showSuccess().then(
                                        function () {
                                            if (window.location.pathname.includes('cockpit'))
                                                $('#service-request-modal').modal('hide');
                                            else
                                                window.location.reload();
                                                console.log(response);
                                        }
                                    )
                                }
                            );
                        }else{
                            SaveBtn.stopLoading().then(
                            () => {
                                SaveBtn.showError()
                            });
                        }
                    },
                    error: (response) => {
                        SaveBtn.stopLoading().then(
                            () => {
                                SaveBtn.showError()
                            });
                    }
                });
            }
        });
    },
    createSubscriptionRequest() {
        $('#create-subscription-btn').on('click', (e) => {
            e.preventDefault();
            const form = $(e.target).parents('form');
            let dataSubscription = form.serialize();
            this.nextSubscriptionStep(dataSubscription, form)
            /*const formSelector =  document.querySelector('#'+form.attr('id'));
            let dataObj = Object.fromEntries(new FormData(formSelector).entries());
            dataObj.end_time = form.find('#time').find(':selected').text().split('-')[1];*/
        });
    },
    nextSubscriptionStep(prevStepData, prevForm){
        let prevStep = prevForm.data('step');
        let nextStep = prevStep + 1;
        let nextForm = $('.order-form-step-' + nextStep);
        $('.order-form-steps').addClass('d-none');
        nextForm.toggleClass('d-none');
        $('#service-request-modal .modal-title').text('Add a Customer');
        $('button', nextForm).off();
        $('button', nextForm).on('click', (e) => {
            e.preventDefault();

            let validateResult = true;

            if (!$('.create-new-customer').hasClass('d-none')) {
                validateResult = this.validateCustomer();
            }

            if (validateResult) {
                let SaveBtn = new SaveButton('.order-form-step-' + nextStep);
                let formData = nextForm.serialize() + '&' + prevStepData;
                $.ajax({
                    type: 'POST',
                    data: formData,
                    url: '/subscription/create',
                    beforeSend: () => {
                        SaveBtn.startLoading();
                    },
                    success: response => {
                        SaveBtn.stopLoading(true).then(() => {
                            SaveBtn.showSuccess().then(() => setTimeout(() => {
                                $('#service-request-modal').modal('hide')
                                location.reload()
                            }, 2000))
                        });
                    },
                    error: (response) => {
                        SaveBtn.stopLoading().then(
                            () => {
                                SaveBtn.showError()
                            });
                    }
                });
            }
        });

    },
    editSubscription() {
        $('#edit-subscription-btn').on('click', (e) => {
            // This direct modal handler is authoritative. Stop the legacy
            // document-level table handler from submitting a second request.
            e.stopImmediatePropagation();
            this.SaveBtn = new SaveButton();
            e.preventDefault();
            const form = $(e.target).parents('form');
            let formData = form.find('[data-is-main="1"], .modal-service-attributes__list:not(.d-none) [name]', form).serialize();
            const id = form.find('input[name="id"]').val();

            $.ajax({
                type: 'POST',
                data: formData,
                // data: dataObj,
                url: `/subscription/${id}/update`,
                beforeSend: () =>{
                    this.SaveBtn.startLoading();
                },
                success: (response) => {
                    this.SaveBtn.stopLoading(true).then(() => {
                        this.SaveBtn.showSuccess().then(()=> $('#service-request-modal').modal('hide'))
                    });
                },
                error: (response) => {
                    this.SaveBtn.showError();
                }
            });
        });
    },
    serviceAttributeChangesValue() {
        $('[data-is-main="1"], .modal-service-attributes__list:not(.d-none) [name]').on('change', () => {
            this.calculateOrderSubtotal();
        });
    },
    calculateOrderSubtotal() {
        let sum =0;
        const percentModifier = parseFloat(document.querySelector(`[data-percent-multiple]`)?.value ?? 0);
        const modifiersPrice = parseFloat(document.querySelector(`[data-modifiers-price]`)?.value ?? 0);
        const servicePrice = parseFloat($(`select[name="service"]`).find(':selected').data('price'));
        let modifiers = Array.from(document.getElementsByClassName('modifier-select'));
        let cb = Array.from(document.getElementsByClassName('modifier-checkbox'));
        modifiers = modifiers.concat(cb);
        sum = servicePrice;
        let percentMultiple = 1;
        modifiers.forEach(element => {
            if ($(element).hasClass('modifier-checkbox')) {
                if ($(element).is(':checked')) {
                    let value = JSON.parse($(element).val());
                    if (value.price) {
                        sum = sum + parseFloat(value.price);
                    }else if(value.percent){
                        // Checkbox rows used the raw percent where the select branch below
                        // divides by 100, so a 10% option multiplied the price by 11.
                        percentMultiple += parseFloat(value.percent) / 100;
                    }
                }
            } else {

                if ($(element).find(':selected').data('price')) {
                    sum = sum + parseFloat($(element).find(':selected').data('price'));
                }else if($(element).find(':selected').data('percent')){
                    percentMultiple += parseFloat($(element).find(':selected').data('percent'))/100;
                }
            }
        });

        sum *= percentMultiple;
        let total = 0;
        const addPercents = percentModifier * modifiersPrice / 100;
        const taxPercent = $(`[data-tax-percent]`).val();
        let tax = 0;
        if (taxPercent>0) {
            tax = parseFloat(document.querySelector('.service-estimate-pricing__tax-value').innerText);
            tax = parseFloat(sum*taxPercent/100);
            total +=tax;
        }
        let tips = parseFloat($('[name="tips"]').val()) ?? 0;
        if (tips>0) {
            total +=tips;
        }
        total += sum;

        if(document.querySelector('.service-estimate-pricing__sub-total-value')) {
            document.querySelector('.service-estimate-pricing__sub-total-value').innerText = sum.toFixed(2);
        }
        if(document.querySelector('.service-estimate-pricing__tax-value')) {
            document.querySelector('.service-estimate-pricing__tax-value').innerText = tax.toFixed(2);
        }
        if(document.querySelector('.service-estimate-pricing__total-value')) {
            document.querySelector('.service-estimate-pricing__total-value').innerText = total.toFixed(2);
        }
    },
    tipsChange() {
        $('body').on('change', '[name="tips"]', (e) => {
            $('[data-sub-total-tips]').html(parseFloat($(e.target).val()).toFixed(2));
            this.calculateOrderSubtotal();
        });
    },
    checkStatusClass() {
        const allSelects = $('.status select');
        allSelects.parents('tr').removeClass('inactive');

        const allInactiveStatuses = $('.status select option[value=0]:selected');
        allInactiveStatuses.parents('tr').addClass('inactive');
    },
    changeStatus() {

        const changeStatusBlick = (selectElement, success=true) => {
            const successColor = '#85D700';
            const errorColor = '#E10000';
            const defaultColor = 'none';
            const resultColor = success ? successColor : errorColor;
            selectElement.css('background', resultColor);
            setTimeout(() => {
                selectElement.css('background', defaultColor);
            }, 100);

            this.checkStatusClass();
        }

        $(document).on('change', '.order-status-select, .subscription-status-select, .confirmation-statuses-select', function() {
            const selectElement = $(this);
            const dataRow = selectElement.parents('tr');
            const entityClass = $(dataRow).data('type') ?? selectElement.attr('class').split('-').shift();
            const entityId = $(dataRow).data('id');
            const status = selectElement.val();

            $.ajax({
                url: `${location.origin}/${entityClass}/${entityId}/change-status`,
                data: { status },
                method: 'POST',
                success: () => {
                    changeStatusBlick(selectElement);
                },
                error: () => {
                    changeStatusBlick(selectElement, false);
                }
            });
        });
    },
    findOrder() {
        const showFindedOrders = (findedOrders) => {
            $('.data-row').addClass('d-none');
            for (let findedOrderId of findedOrders) {
                $(`.data-row[data-id=${findedOrderId}]`).removeClass('d-none');
            }
        }
        const checkEmptyDaysGroup = () => {
            const daysGroups = $('.date-description-row');
            for (let daysGroup of daysGroups) {
                daysGroup = $(daysGroup);
                const day = daysGroup.data('day');

                const allOrdersInThisDay = $(`.data-row[data-day=${day}]`);
                const unvisibleOrders = $(`.data-row[data-day=${day}].d-none`);

                if (allOrdersInThisDay.length == unvisibleOrders.length) daysGroup.addClass('d-none');
                else daysGroup.removeClass('d-none');
            }
        }
        const showAllOrders = () => {
            $('.date-description-row').removeClass('d-none');
            $('.data-row').removeClass('d-none');
        }
        $('select[name=worker], select[name=customer]').on('change', function() {
            const searchInOrderId = this.value;

            if (searchInOrderId == 0) showAllOrders();
            else {
                $.ajax({
                method: 'GET',
                url: '/order/find',
                data: {id: searchInOrderId},
                success: (findedOrders) => {
                        showFindedOrders(findedOrders);
                        checkEmptyDaysGroup();
                    }
                });
            }
        });
    },
    assignWorkers() {
        let _this = this;
        $('body').on('click', '.assign-workers', function () {
            const current = $(this);
            const entityName = current.parents('table').data('entity')
            const row = current.parents('.data-row');
            const Entity = CRUDFabric.getClass(entityName);
            const entityObj = new Entity(row.data('id'));
            entityObj.openModal('assing_workers');
            if (entityObj.entityClass !== 'order') {
                _this.assingAction(entityObj.entityClass);
            }
        });
        $('#form-container').on('change', '.worker-row input[type=checkbox]', function () {
            const checkbox = $(this);
            const workerId = checkbox.parents('.worker-row').attr('data-id');
            if (checkbox.prop('checked')) HasWorkers.choseWorker(workerId);
            else HasWorkers.deleteWorker(workerId);
        });
        $('#form-container').on('click', '.selected-worker .delete', function () {
            const workerId = $(this).parents('.selected-worker').data('id');
            HasWorkers.deleteWorker(workerId);
        });

        $('#form-container').on('click', '#assing_workers-order-modal #assing_workers', function () {
            const form = $(this).parents('form');
            const id = form.find('[name=id]').val();
            const entityName = form.data('entity')
            const Entity = CRUDFabric.getClass(entityName);
            const entityObj = new Entity(id);
            entityObj.assingWorkers(() => {
                location.reload()
            });
        });
    },
    assingAction(modal_name){
        $('#form-container').on('click', `#assing_workers-${modal_name}-modal #assing_workers`, function () {
            const form = $(this).parents('form');
            const id = form.find('[name=id]').val();
            const entityName = form.data('entity')
            const Entity = CRUDFabric.getClass(entityName);
            const entityObj = new Entity(id);
            entityObj.assingWorkers(() => {
                location.reload(true);
            });
        });
    },
    moreInfoOrder() {
        $('body').on('click', '.data-row:not([data-origin]) .more-btn', function() {
            let $button = $(this);

            if (!$button.prop('disabled')) {
                const paymentId = $(this).data('for-order');
                const moreInfoContainer = $(`[data-order-id=${paymentId}].more-info-container`);
                moreInfoContainer.toggleClass('d-none');

                const arrow = $(this).parents('td').find('.arrow');
                const arrow_new = $(this).parents('td').find('.arrow-new');
                // Mobile
                const svgOpenButton = $(this).parent('td').find('svg.svg-open');
                const svgCloseButton = $(this).parent('td').find('svg.svg-close');
                // Mobile
                const statusContainer = $(this).parents('td').find('span');
                if (moreInfoContainer.length>0) {
                    if (moreInfoContainer.hasClass('d-none')) {
                        svgCloseButton.addClass('d-none').removeClass('d-flex');
                        svgOpenButton.addClass('d-flex').removeClass('d-none');

                        arrow.css({'transform': 'rotate(45deg)', 'top' : '12px'});
                        arrow_new.css({'transform': 'rotate(45deg)', 'bottom' : '3px'});
                        statusContainer.text('More');
                    } else {
                        svgCloseButton.addClass('d-flex').removeClass('d-none');
                        svgOpenButton.addClass('d-none').removeClass('d-flex');

                        arrow.css({'transform': 'rotate(225deg)', 'top' : '15px'});
                        arrow_new.css({'transform': 'rotate(225deg)', 'bottom' : '0px'});
                        statusContainer.text('Close');
                    }
                }
                $button.prop('disabled', true);
            }
            setTimeout(function() {
                $button.prop('disabled', false);
            }, 400);
        });

    },
    openViewInvoiceModal(){
        $('body').off('click','.more-info-actions .view-invoice')
        .on('click', '.more-info-actions .view-invoice', function () {
            const invoiceId = $(this).parent('.more-info-actions').parent('td').parent('tr').data('invoice-id');
            const invoice = new Invoice(invoiceId);
            invoice.openModal('view');
        });
    },
    openPayInvoice(){
        $('body').off('click', '.more-info-actions .pay-invoice')
        .on('click', '.more-info-actions .pay-invoice', function () {
            const invoiceId = $(this).parent('.more-info-actions').parent('td').parent('tr').data('invoice-id');
            const invoice = new Invoice(invoiceId);
            invoice.openModal('payment');
            new PaymentForm(invoice);
        });
    },
    /*openViewQuote(){
        $('body').off('click','.more-info-actions .view-quote')
        .on('click', '.more-info-actions .view-quote', function() {
            const quoteId =  $(this).parent('.more-info-actions').parent('td').parent('tr').data('quote-id');
            const quote = new Quote(quoteId);
            quote.openModal('view');
        });
    },
    openApproveQuote(){
        $('body').off('click','.more-info-actions .approve-quote')
        .on('click','.more-info-actions .approve-quote', function() {
            const quoteId =  $(this).parent('.more-info-actions').parent('td').parent('tr').data('quote-id');
            const quote = new Quote(quoteId);
            ApproveQuoteForm.init(quote);
        });
    },*/
    moreInfoSubscription() {
        $(document).on('click', '[data-origin] .more-btn', function() {
            let $button = $(this);

            if (!$button.prop('disabled')) {
                const moreContainerOriginId = $(this).parents('.data-row').attr('data-origin');
                const moreContainerTarget = $(`.more-info-container[data-target=${moreContainerOriginId}]`);
                moreContainerTarget.toggleClass('d-none');
                const arrow = $(this).parents('td').find('.arrow');
                const arrow_new = $(this).parents('td').find('.arrow-new');
                const statusContainer = $(this).parents('td').find('span');
                if (moreContainerTarget.hasClass('d-none')) {
                    arrow.css({'transform': 'rotate(45deg)', 'top' : '12px'});
                    arrow_new.css({'transform': 'rotate(45deg)', 'bottom' : '3px'});
                    statusContainer.text('More');
                } else {
                    statusContainer.text('Close');
                    arrow.css({'transform': 'rotate(225deg)', 'top' : '15px'});
                    arrow_new.css({'transform': 'rotate(225deg)', 'bottom' : '0px'});
                }
                $button.prop('disabled', true);

                setTimeout(function() {
                    $button.prop('disabled', false);
                }, 1500);
            }
        });
    },
    openJobDetail(){
        // view details - not complete!!!
        $('body').off('click', '.more-info-actions .job-details')
        .on('click','.more-info-actions .job-details', function () {
            const jobId =  $(this).parent('.more-info-actions').parent('td').parent('tr').data('jobs-id');
            const job = new Job(jobId);
            job.openModal('view');
        });
    },
    openJobInvoices(){
        $('body').off('click', '.more-info-actions .job-details-invoices')
        .on('click','.more-info-actions .job-details-invoices', function () {
            const jobId =  $(this).parent('.more-info-actions').parent('td').parent('tr').data('jobs-id');
            const job = new Job(jobId);
            const result = job.relatedEntities('invoices');
        });
    },
    editOrder() {
        $('body').on('click', '.pre-edit-btn', (e) => {
            e.preventDefault();
            let form = $(e.target).parents('form').parent();
            $(form).find('select, input, textarea').attr('disabled', false).css('background', '');
            $(form).find('textarea').attr('readonly', false);
            $(form).find('button').text('Save').removeClass('pre-edit-btn').addClass('update-order-service');
            $(form).find('.arrow').removeClass('d-none');
        })
        $('body').on('click', '.update-order-service', (e) =>{
            e.preventDefault();
            let SaveBtn = new SaveButton();
            let form = $(e.target).parents('form');
            $('[name="time"]').find('option:selected').val($('[name="time"]').find('option:selected').text());
            let formData = form.serialize();
            formData += '&'+$('#customer_id').serialize();
            if ($('.subscription_modifier').length>0 && formData.search('subscription_modifier')<0) {
                formData += '&'+$('.subscription_modifier').removeAttr('disabled').serialize();
                $('.subscription_modifier').attr('disabled', true);
            }

            $.ajax({
                type: 'POST',
                data: formData,
                url: '/create-order',
                beforeSend: () =>{
                    SaveBtn.startLoading();
                },
                success: (response) => {
                    SaveBtn.stopLoading().then(
                        () => {
                            SaveBtn.showSuccess().then(
                                function() {
                                    if(window.location.pathname.includes('cockpit')){
                                        $('#service-request-modal').modal('hide');
                                    }else{
                                        window.location.reload();
                                    }
                                    console.log(response);
                                }
                            )
                        }
                    );
                },
                error: (response) => {
                    SaveBtn.showError();
                }
            });
        })
    },
    getDetailsForm(){
        $('body').on('click', '.orders .view-appointment-details',function(e) {
            e.preventDefault();
            if ( typeof($(this).find('a').data('order-id')) == 'undefined') {
                return;
            }
            let data = {
                id: $(this).find('a').data('order-id'),
                type: 'appointment',
            };
            $.ajax({
                type: 'GET',
                url: '/services-management/categories/get-additional-form',
                data: data,
                success: (response) => {
                    $('#form-container').html(response);
                    $('#view-details-form-modal').modal('show');
                },
                error: (response) => {
                    console.log(response);
                },
            });
        });

        $('body').on('click','.subscriptions .view-subscription-details',function(e) {
            e.preventDefault();
            if ( typeof($(this).find('a').data('subscription-id')) == 'undefined') {
                return;
            }
            let data = {
                id: $(this).find('a').data('subscription-id'),
                type: 'subscription',
            };
            $.ajax({
                type: 'GET',
                url: '/services-management/categories/get-additional-form',
                data: data,
                success: (response) => {
                    $('#form-container').html(response);
                    $('#subscription-details-modal').modal('show');
                },
                error: (response) => {
                    console.log(response);
                },
            });
        });
    },

    // view checklist
    viewChecklist() {
        $('body').on('click','.appointment-checklist-view', function () {
            const checkListId = $(this).data('checklist-id');
            const checkList = new CheckList(checkListId);
            checkList.view();
        });
    },
    // mark as done
    markChecklistItemsDone() {
        $('#form-container').on('click', '#checklist-view-modal .mark-as-done', function () {
            //text
            $(this).closest('.jobs-list').find('div,input,button').toggleClass('text-muted')
            //button
            $(this).closest('.mark-as-done').val() == "Done" ?
                $(this).closest('.mark-as-done').val('Mark as Done') :
                $(this).closest('.mark-as-done').val("Done")
            //info
            $(this).parent().children().first().val() == '1' ?
                $(this).parent().children().first().val('0') :
                $(this).parent().children().first().val('1')

        })
    },

    // view checklist log
    viewChecklistLog() {
        $('#form-container').on('click', '#checklist-view-modal .log-view', function () {
            const checkListId = $(this).data('checklist-id');
            const checkList = new CheckList(checkListId);
            checkList.log();
        });
    },
    saveChecklistJobsDone() {
    //mark jobs done
        $('#form-container').on('click', '#checklist-view-modal .save-view', function () {

            let jobMarks = $('.marked-done').serialize()
            let comment = $('.done-comment').val().trim()
            let checklist_id = $('.mark-as-done').data('checklist-id')

            $.ajax({
                url: `/jobs-flow/checklist/${checklist_id}/done`,
                type: "POST",
                data: {jobMarks, comment, checklist_id},
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                },
                error: function (msg) {
                }
            });
            $('#checklist-view-modal').modal('hide')

        })
    },

    validateCustomer() {
        let email = $(".create-new-customer [name='email']");
        let phone = $(".create-new-customer [name='phone']");
        let first_name = $(".create-new-customer [name='first_name']");
        let last_name = $(".create-new-customer [name='last_name']");
        let errors = 0;

        if (/^\S+@\S+\.\S+$/.test(email.val())) {
            email.attr('style', '');
        } else {
            email.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (/^\d{3}-\d{3}-\d{4}$/.test(phone.val())) {
            phone.attr('style', '');
        } else {
            phone.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (first_name.val().length > 0) {
            first_name.attr('style', '');
        } else {
            first_name.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (last_name.val().length > 0) {
            last_name.attr('style', '');
        } else {
            last_name.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        return (errors > 0) ? false : true;
    },

    allMoreInfo(){
        const tables = ['invoices','requests','quotes']
        for(const table of tables){
            $('body').off('click', `.data-view.${table} td.more .more-btn`)
                .on('click', `.data-view.${table} td.more .more-btn`, function () {
                    const attrName = table.replace(/s$/,'')
                    const entityId = $(this).data(`for-${attrName}`);
                    const moreInfoContainer = $(`[data-${attrName}-id=${entityId}].more-info-container`);
                    moreInfoContainer.toggleClass('d-none');
                    const svgOpenButton = $(this).parent('td').find('svg.svg-open');
                    const svgCloseButton = $(this).parent('td').find('svg.svg-close');

                    if (moreInfoContainer.hasClass('d-none')) {
                        svgCloseButton.addClass('d-none').removeClass('d-flex');
                        svgOpenButton.addClass('d-flex').removeClass('d-none');
                    } else {
                        svgCloseButton.addClass('d-flex').removeClass('d-none');
                        svgOpenButton.addClass('d-none').removeClass('d-flex');
                    }
                });
        }

    },

    leaveComments(){
        $('body').on('click', '.data-view.orders .leave-comments', function() {
            const entityType = $(this).data('type');
            const entityId = $(this).data(`${entityType}-id`);

            $('#leave-comments-modal').modal('show');
            $('#leave-comments-modal button.comment-button').data('job-id', entityId);
            $('#leave-comments-modal button.comment-button').data('type', entityType);
        });
    }

}
